
























import {
  defineComponent,
  PropType,
  ref,
  toRefs,
  useRoute,
  watch
} from '~/utils/nuxt3-migration'
import MobileMenuEntry from '~/components/car/header/MobileMenuEntry.vue'
import { MobileMenuItem } from '~/models/header/mobile-menu'
import { useDep } from '~/compositions/dependency-container'
import ClassifiedSearchService from '~/services/search/ClassifiedSearchService'
import { useRequestError } from '~/compositions/request-error'
import { categoriesIconsMappings } from '~/constants/category/icon'
import { resolveCategory } from '~/utils/category'
import { ciThreeDots } from '~/icons/source/thin/three-dots'

export default defineComponent({
  components: { MobileMenuEntry },
  props: {
    menu: {
      type: Object as PropType<MobileMenuItem>,
      required: true
    },
    selectedMenus: {
      type: Array as PropType<string[]>,
      required: true
    },
    clickFunction: {
      type: Function,
      required: true
    },
    navigateFunction: {
      type: Function,
      required: false,
      default: null
    },
    topOffset: {
      type: Number,
      default: 0
    },
    transitioning: {
      type: Boolean,
      default: false
    },
    paddingClass: {
      type: String,
      default: undefined
    }
  },
  setup(props) {
    const loading = ref(false)
    const menuItems = ref<MobileMenuItem[]>([])

    const route = useRoute()

    const { selectedMenus } = toRefs(props)

    const handleRequestError = useRequestError()
    const classifiedSearchService = useDep(ClassifiedSearchService)

    watch(selectedMenus, val => {
      if (val.includes(`sub-${props.menu.key}`)) {
        fetchMenu()
      }
    })

    async function fetchMenu() {
      if (menuItems.value.length) {
        return
      }
      loading.value = true
      try {
        const params = {
          category: props.menu.id,
          context: ['quick-search']
        }

        const data = await classifiedSearchService.getFacets(params)

        const categoryFacet = data.facets.find(
          f => f.type === 'CategoryTreeSearchHandler'
        )

        if (categoryFacet) {
          menuItems.value = categoryFacet.searchables.map(s => {
            return {
              key: s.v,
              title: s.n,
              id: s.v,
              link: s.seoUrl,
              useNuxtLink: !route.value.name?.startsWith(
                '__classifieds_search'
              ),
              icon:
                resolveCategory(categoriesIconsMappings, [s.v]) || ciThreeDots
            }
          })
        }
        if (menuItems.value.length) {
          loading.value = false // only on success
        }
      } catch (error) {
        handleRequestError(error)
      }
    }

    return {
      loading,
      menuItems
    }
  }
})
